<template>
  <v-app id="keep">
    <router-view />
  </v-app>
</template>

<script>
export default {
  data() {
    return {}
  },

  components: {},

  methods: {},

  name: "App",

  computed: {},

  watch: {},

  mounted: function() {
    console.log("mounted APP.VUE")
  }
}
</script>

<style>
.clicker {
  cursor: pointer;
}
.clickableTable tr {
  cursor: pointer;
}
</style>
